export const StaticSessionEmailEnum = {
  STATIC_BUILDER_EMAIL_MODAL_OPEN: 'STATIC_BUILDER_EMAIL_MODAL_OPEN',
  STATIC_BUILDER_EMAIL_MODAL_CLOSE: 'STATIC_BUILDER_EMAIL_MODAL_CLOSE',
  STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_REQUEST: 'STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_REQUEST',
  STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_SUCCESS: 'STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_SUCCESS',
  STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_FAILURE: 'STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_FAILURE',
};

export const StaticSessionEmailNotifications = {
  failure: 'Your email could not be sent.',
};



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/SessionEmail/SessionEmailConstants.jsx